var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Card, CardContent, Typography, Grid, IconButton, } from "@mui/material";
import { useSelector } from "react-redux";
import { memo, useEffect, useState } from "react";
// @ts-ignore
import { selectors } from "paul-core-package";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { CompareTwoGraph } from "./CompareTwoGraph";
import { ComparingTwoValuesInfo } from "./ComparingTwoValuesInfo";
import { CompareTwoValuesExplanation } from "./CompareTwoValuesExplanation";
var TRANSLATIONS;
(function (TRANSLATIONS) {
    TRANSLATIONS["EMPTY_ENERGY_SAVING_MESSAGE"] = "EMPTY_ENERGY_SAVING_MESSAGE";
})(TRANSLATIONS || (TRANSLATIONS = {}));
export var CompareTwoValues = memo(function (_a) {
    var data = _a.data;
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    var referenceValueValue = data.referenceValueValue, focusValueValue = data.focusValueValue, isHiddenNegativePercentage = data.isHiddenNegativePercentage, referenceValueTitle = data.referenceValueTitle, referenceValueUnit = data.referenceValueUnit, focusValueTitle = data.focusValueTitle, focusValueUnit = data.focusValueUnit, percentageTitle = data.percentageTitle, description = data.description;
    var isValue = Boolean(data.referenceValueValue || data.focusValueValue);
    var isReferenceValueShouldBeReassigned = referenceValueValue &&
        focusValueValue &&
        isHiddenNegativePercentage &&
        referenceValueValue <= focusValueValue;
    var reassignedReferenceValue = isReferenceValueShouldBeReassigned
        ? focusValueValue
        : referenceValueValue;
    var _b = useState(""), message = _b[0], setMessage = _b[1];
    var _c = useState(false), isExplanationMode = _c[0], setIsExplanationMode = _c[1];
    var toggleExplanationMode = function () {
        setIsExplanationMode(!isExplanationMode);
    };
    var switchExplanationMode = function () {
        setIsExplanationMode(true);
    };
    useEffect(function () {
        setMessage(tI[TRANSLATIONS.EMPTY_ENERGY_SAVING_MESSAGE]);
    }, [tI[TRANSLATIONS.EMPTY_ENERGY_SAVING_MESSAGE]]);
    return (_jsxs(Card, __assign({ sx: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "8px 16px 0",
        } }, { children: [_jsx(CardContent, { children: _jsxs(Grid, __assign({ container: true, justifyContent: "space-between", gap: 2, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsx(Typography, __assign({ variant: "body1", color: "text.secondary", sx: { wordWrap: "break-word" } }, { children: data.headlineTitle })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(IconButton, __assign({ "aria-label": isExplanationMode ? "Close" : "Info", onClick: toggleExplanationMode }, { children: isExplanationMode ? _jsx(CloseOutlinedIcon, {}) : _jsx(InfoOutlinedIcon, {}) })) }))] })) }), _jsxs(CardContent, __assign({ sx: {
                    minHeight: "314px",
                    flexGrow: "1",
                    paddingTop: 3,
                    "&:last-child": {
                        pb: 0,
                    },
                } }, { children: [isExplanationMode && _jsx(CompareTwoValuesExplanation, {}), !isExplanationMode && (_jsx(Grid, __assign({ container: true, height: "100%", gap: 3 }, { children: isValue ? (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, xs: true }, { children: _jsx(CompareTwoGraph, { twoBarsReferenceBar: reassignedReferenceValue, twoBarsFocusBar: focusValueValue }) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(ComparingTwoValuesInfo, { referenceValue: reassignedReferenceValue, referenceValueTitle: referenceValueTitle, referenceValueUnit: referenceValueUnit, focusValue: focusValueValue, focusValueTitle: focusValueTitle, focusValueUnit: focusValueUnit, percentageTitle: percentageTitle, description: description, action: switchExplanationMode }) }))] })) : (_jsx(Box, __assign({ sx: {
                                display: "flex",
                                width: "100%",
                                height: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                p: 6,
                            } }, { children: _jsx(Typography, __assign({ textAlign: "center", variant: "body1", color: "text.disabled" }, { children: message })) }))) })))] }))] })));
});
